import { useNavigate } from "react-router-dom";
import { Zap, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BacktestLayoutProps {
  children: React.ReactNode;
  backLabel?: string;
  backTo?: string;
}

export function BacktestLayout({
  children,
  backLabel = "Dashboard",
  backTo = "/",
}: BacktestLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/60 bg-card/80 backdrop-blur-md sticky top-0 z-50">
        <div className="w-full px-6 py-3 flex items-center gap-4">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2.5 hover:opacity-80 transition-opacity"
          >
            <div className="w-8 h-8 rounded-lg gradient-primary flex items-center justify-center shadow-primary">
              <Zap className="w-3.5 h-3.5 text-primary-foreground" />
            </div>
            <span className="text-sm font-display font-bold text-foreground">DiscoRun</span>
          </button>

          <span className="text-border text-lg font-light">/</span>

          <span className="text-sm font-medium text-foreground">Backtest</span>

          <div className="ml-auto">
            <Button
              variant="ghost"
              size="sm"
              className="h-8 text-xs"
              onClick={() => navigate(backTo)}
            >
              <ArrowLeft className="w-3.5 h-3.5 mr-1.5" />
              {backLabel}
            </Button>
          </div>
        </div>
      </header>

      <main className="w-full px-6 py-6">{children}</main>
    </div>
  );
}
